// extracted by mini-css-extract-plugin
module.exports = {"root":"lQ1Xjki4","header":"TVlZMXlv","headerContent":"CGqrSd4G","icon":"nxEnCzPl","title":"CXT64V5x","closeButton":"EDNPkYvE","body":"ZAW2dsT2"};